// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Description: This is a CSS reset for use in personal projects.
 * Author: Pedro Augusto (https://github.com/PedroASB)
 *
 * Based on: 
 *   - Matt Brictson's recommendations (https://mattbrictson.com/blog/css-normalize-and-reset)
 *   - Josh Comeau's custom CSS reset (https://www.joshwcomeau.com/css/custom-css-reset/)
 */

/* Use box-sizing model */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* Remove default margin */
* {
  margin: 0;
}

body {
  /* Add accessible line-height */
  line-height: 1.5;
  /* Improve text rendering */
  -webkit-font-smoothing: antialiased;
}

/* Improve media defaults */
img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

/* Inherit fonts for form controls */
input,
button,
textarea,
select {
  font: inherit;
}

/* Remove the list styles when role="list" is present 
   (keep list semantics but hide the bullets in those cases) */
ol[role='list'],
ul[role='list'] {
  list-style: none;
  padding-inline: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  /* Reset heading font styles */
  font-size: inherit;
  font-weight: inherit;
  line-height: 1.15;
  /* Improve line wrapping */
  overflow-wrap: break-word;
  text-wrap: balance;
}

p {
  /* Improve line wrapping */
  overflow-wrap: break-word;
  text-wrap: pretty;
}
`, "",{"version":3,"sources":["webpack://./src/css/reset.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF,yBAAyB;AACzB;;;EAGE,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,2BAA2B;AAC3B;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA,oCAAoC;AACpC;;;;EAIE,aAAa;AACf;;AAEA;8DAC8D;AAC9D;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;;EAME,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;AACnB","sourcesContent":["/*\n * Description: This is a CSS reset for use in personal projects.\n * Author: Pedro Augusto (https://github.com/PedroASB)\n *\n * Based on: \n *   - Matt Brictson's recommendations (https://mattbrictson.com/blog/css-normalize-and-reset)\n *   - Josh Comeau's custom CSS reset (https://www.joshwcomeau.com/css/custom-css-reset/)\n */\n\n/* Use box-sizing model */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* Remove default margin */\n* {\n  margin: 0;\n}\n\nbody {\n  /* Add accessible line-height */\n  line-height: 1.5;\n  /* Improve text rendering */\n  -webkit-font-smoothing: antialiased;\n}\n\n/* Improve media defaults */\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\n/* Inherit fonts for form controls */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* Remove the list styles when role=\"list\" is present \n   (keep list semantics but hide the bullets in those cases) */\nol[role='list'],\nul[role='list'] {\n  list-style: none;\n  padding-inline: 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  /* Reset heading font styles */\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: 1.15;\n  /* Improve line wrapping */\n  overflow-wrap: break-word;\n  text-wrap: balance;\n}\n\np {\n  /* Improve line wrapping */\n  overflow-wrap: break-word;\n  text-wrap: pretty;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
